/**
 * <selling-plan-selector form="product-form-id">
 *
 * Wraps either the single "Subscribe & Save" checkbox or the multi-plan
 * radio list rendered by snippets/gv-selling-plan-selector.liquid. On
 * change, syncs the chosen selling plan id into a hidden `selling_plan`
 * input inside the bound <product-form> — omitting the field entirely for
 * a one-time purchase, which is how Shopify's cart/add.js expects it.
 *
 * Mirrors the same JS-syncs-a-hidden-input pattern already used by
 * assets/gv-offers.js, rather than relying on cross-boundary native
 * `form="..."` attribute association, for consistency and robustness.
 *
 * Dispatches a bubbling `selling-plan:change` event (detail: { sellingPlanId })
 * so other components (e.g. a live price display) can react later without
 * being tightly coupled to this element.
 */
if (!window.customElements.get('selling-plan-selector')) {
	class SellingPlanSelector extends HTMLElement {
		connectedCallback() {
			this._form = document.forms[this.getAttribute('form')]
			if (!this._form) {
				return
			}
			this._onChangeListener = this._onChange.bind(this)
			this.addEventListener('change', this._onChangeListener)
		}

		disconnectedCallback() {
			this.removeEventListener('change', this._onChangeListener)
		}

		_onChange(event) {
			const input = event.target
			let sellingPlanId = ''

			if (input.type === 'checkbox') {
				sellingPlanId = input.checked
					? input.getAttribute('data-selling-plan-id')
					: ''
			} else if (input.type === 'radio') {
				sellingPlanId = input.getAttribute('data-selling-plan-id') || ''
			} else {
				return
			}

			this._syncSellingPlan(sellingPlanId)

			this.dispatchEvent(
				new CustomEvent('selling-plan:change', {
					bubbles: true,
					detail: { sellingPlanId },
				}),
			)
		}

		_syncSellingPlan(sellingPlanId) {
			let planInput = this._form.querySelector('input[name="selling_plan"]')

			if (!sellingPlanId) {
				planInput?.remove()
				return
			}

			if (!planInput) {
				planInput = document.createElement('input')
				planInput.type = 'hidden'
				planInput.name = 'selling_plan'
				this._form.appendChild(planInput)
			}
			planInput.value = sellingPlanId
		}
	}

	window.customElements.define('selling-plan-selector', SellingPlanSelector)
}
